export default __webpack_public_path__ + "static/media/whatsapp.680fa044.png";